import { putUpdateClassroom } from "../../../../api/hours/hoursApi";
import { getTdtKey } from "../../../../util/constants/Constants";
import { debounce } from "../../../../util/helper/DebounceHelper";
import { HudGlobal } from "../../../../util/HudGlobal";
import { formatterPoiAddress, getRegionName, transformToGCJ02 } from "../../util/signInFormatter";
let controller = null;
export default {
    name: "UpdateClassroomAddressDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        dialogObject: {
            type: Object,
            default: () => {},
        },
        signTypeName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            formObject: {
                classroomAddress: "",
                longitude: "",
                latitude: "",
            },
            suggestList: [], // 搜索建议列表
            loading: false,
        };
    },
    computed: {
        getRule() {
            return {
                // 说明
                classroomAddress: [{ required: true, message: "请输入地址后，选择下拉框搜索的详细地址", trigger: "change" }],
            };
        },
        /**
         * 是否支持app验证
         */
        isSupportApp() {
            if (this.dialogObject && this.dialogObject.faceLiveDetectionApp == 1 && this.dialogObject.isFaceVerify) {
                return true;
            }
            return false;
        },
    },
    watch: {
        visible: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.setupInit();
                }
            },
        },
    },
    methods: {
        setupInit() {
            this.$refs.form && this.$refs.form.resetFields();
        },
        /**
         * 关闭
         */
        onCloseEvent() {
            this.$emit("update:visible", false);
        },
        onSureClose() {
            if (this.isSupportApp) {
                this.$emit("openScan");
            }
            this.onCloseEvent();
        },
        onSureEvent() {
            this.$refs.form &&
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        const params = Object.assign(
                            {
                                classroomName: this.dialogObject.classroomName,
                                classroomId: this.dialogObject.classroomId,
                                id: this.dialogObject.id,
                                offlineRecordId: this.dialogObject.offlineRecordId,
                                orgId: this.dialogObject.orgId,
                            },
                            this.formObject
                        );
                        putUpdateClassroom(params)
                            .then((res) => {
                                this.loading = false;
                                if (res.success) {
                                    HudGlobal.showSuccessWithMessage("更新成功！");
                                    this.$emit("callback", this.formObject);
                                    this.onCloseEvent();
                                } else {
                                    HudGlobal.showErrorWithMessage(res.description || "更新失败！");
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                HudGlobal.showErrorWithMessage(error.description || "更新失败！");
                            });
                    }
                });
        },
        /**
         * 监听详细地址选择
         */
        monitorDetailAddressChange(val) {
            console.log("===详细地址=======", val, this.dialogObject);
            this.formObject.longitude = null;
            this.formObject.latitude = null;
            if (val) {
                const data = val.data;
                const { lonlat } = data;
                if (lonlat && lonlat.length > 0) {
                    const [longitudeStr, latitudeStr] = lonlat.split(",");
                    console.log("原始坐标为：", lonlat);
                    const result = transformToGCJ02(longitudeStr, latitudeStr);
                    console.log("转换之后坐标为：", result);
                    this.formObject.longitude = result[0];
                    this.formObject.latitude = result[1];
                }
            }
        },

        /**
         * 监听地址失去焦点
         */
        validateInputBlur() {
            if (!this.suggestList || this.suggestList.length === 0) return false;
            const that = this;
            setTimeout(() => {
                const values = that.suggestList.map((item) => item.value);
                if (values.indexOf(that.formObject.classroomAddress) == -1) {
                                                                                // HudGlobal.showWarningWithMessage("请从下拉列表中选择有效选项！");
                                                                                that.clearClassRoomAddress();
                                                                            }
            }, 500);
        },
        /**
         * 输入详细地址
         */
        querySearchAsync: debounce(function(queryString, cb) {
            this.suggestList = [];
            // 1. 空值或短查询处理
            if (queryString.length < 1) {
                cb([]);
                return;
            }
            const that = this;
            this.loadTdTSearchSuggest(queryString, getRegionName(this.formObject))
                .then((sourcePoiList) => {
                    if (sourcePoiList && sourcePoiList.length > 0) {
                        const result = sourcePoiList.map((item) => {
                            return {
                                value: formatterPoiAddress(item),
                                data: item,
                            };
                        });
                        this.suggestList = result;
                    } else {
                        this.suggestList = [];
                    }
                    cb && cb(this.suggestList);
                })
                .catch((error) => {
                    console.log("==搜索失败====", error);
                    this.suggestList = [];
                    cb && cb([]);
                });
        }, 1000),

        /**
         * 监听地址失去焦点
         */
        validateInputBlur() {
            if (!this.suggestList || this.suggestList.length === 0) return false;
            const that = this;
            setTimeout(() => {
                const values = that.suggestList.map((item) => item.value);
                if (values.indexOf(that.formObject.classroomAddress) == -1) {
                    HudGlobal.showWarningWithMessage("请从下拉列表中选择有效选项！");
                    that.clearClassRoomAddress();
                }
            }, 500);
        },
        /**
         *  搜索建议
         */
        loadTdTSearchSuggest(queryString, specify) {
            return new Promise((resolve, reject) => {
                // 取消上一次请求
                controller && controller.abort();
                const param = {
                    keyWord: queryString,
                    level: 12,
                    queryType: 7, // 1:普通搜索（含地铁公交） 7：地名搜索
                    mapBound: "73.66,18.15,135.05,53.55",
                    start: 0, // 表示返回结果的起始位置
                    count: 30, // 返回结果的条数。
                    show: 2, //取值为1，则返回基本poi信息； 取值为2，则返回详细poi信息
                };
                const postStr = JSON.stringify(param);
                const url = `https://api.tianditu.gov.cn/v2/search?postStr=${postStr}&type=query&tk=993183a98f4cbf752ca8a5c8f141a330`;
                // 创建新的 AbortController
                controller = new AbortController();
                fetch(url, {
                    method: "GET",
                    signal: controller.signal,
                })
                    .then(async (res) => {
                        try {
                            const response = await res.json();
                            if (response.status.infocode === 1000 && response.pois) {
                                resolve && resolve(response.pois);
                            } else {
                                reject && reject(response);
                            }
                            console.log("========", response);
                        } catch (error) {
                            reject && reject(error);
                        }
                    })
                    .catch((err) => {
                        if (err.name === "AbortError") {
                            console.log("Request was aborted");
                        } else {
                            reject && reject(err);
                        }
                    })
                    .finally(() => {
                        controller = null;
                    });
            });
        },
        /**
         * 清空教室地址
         */
        clearClassRoomAddress() {
            this.formObject.classroomAddress = "";
            this.formObject.longitude = null;
            this.formObject.latitude = null;
        },
    },
};
